import { Injectable } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { SelectArlDialogComponent, SelectArlDialogData, SelectArlDialogReturnData } from './select-arl-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class SelectArlDialogService {
    constructor(private dialog: MatLegacyDialog) {}
    async open(data: SelectArlDialogData) {
        const module = await import('./select-arl-dialog.component');
        return this.dialog.open<SelectArlDialogComponent, SelectArlDialogData, SelectArlDialogReturnData>(module.SelectArlDialogComponent, {
            // ...SelectArlDialogComponent.DefaultConfig,
            data,
        });
    }
}
